import axios from '@!/lib/axios'
import { getCsrfToken } from '@!/Util/postRequest'

export const postAgeVerificationApi = async () => {
  try {
    return await axios.post(
      '/api/v1/age_verification.json',
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCsrfToken(),
        },
      },
    )
  } catch (error) {
    throw new Error(error.message)
  }
}
